import styled from 'styled-components'

export const Root = styled.div({
  position: 'fixed',
  top: 66,
  right: 8,
  maxWidth: '100%',
  maxHeight: 'calc(100% - 72px)',
  width: 425,
  height: 'auto',
  padding: 8,
  zIndex: 999999,
  overflowX: 'hidden',
  boxSizing: 'border-box',
})
